/* ================================================================
   RUB HUB -- tagging strip fitter
   Drops the LOWEST-PRIORITY whole tag pill until the left lane fits.
   Pills are authored high->low priority (left->right); we hide from the
   end. Whole pills only -- never a half tag, never a hang-off. The award
   coin is pinned by CSS and is never touched here.
   Runs at every point the widths can change (DOM ready, full load, web
   fonts ready, resize) and watches for AJAX-loaded cards, so a tag that
   does not fully fit is always DROPPED, never clipped.
   Idempotent: safe to load more than once (per-card include dedupes).
   ================================================================ */
(function () {
  if (window.__rhBadgesFitInit) return;
  window.__rhBadgesFitInit = true;

  function fit(lane) {
    var pills = Array.prototype.slice.call(lane.children);
    pills.forEach(function (p) { p.style.display = ''; });          // reset every pass
    var guard = 0;
    for (var i = pills.length - 1; i >= 0; i--) {
      if (lane.scrollWidth <= lane.clientWidth + 1) break;          // it fits -- stop
      pills[i].style.display = 'none';                              // drop lowest priority
      if (++guard > 20) break;
    }
  }
  function run() {
    var lanes = document.querySelectorAll('.rh-badges__tags');
    for (var i = 0; i < lanes.length; i++) fit(lanes[i]);
  }
  function schedule() { run(); if (window.requestAnimationFrame) requestAnimationFrame(run); }

  // run at every point widths can settle
  if (document.readyState !== 'loading') schedule();
  else document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  setTimeout(schedule, 300);                                        // late-loading fonts/CSS

  var t;
  function debounced() { clearTimeout(t); t = setTimeout(run, 120); }
  window.addEventListener('resize', debounced);

  // re-fit cards injected by AJAX pagination / collection filtering
  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { debounced(); return; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
